import React, { createContext, useContext, useState } from "react";

export const ModalContext = createContext();

export const useModal = () => useContext(ModalContext);

export const ModalProvider = ({ children }) => {
  const [isModalOpen, setModalOpen] = useState(false);
  const [title, setTitle] = useState("");
  const [content, setContent] = useState(null);
  const [action, setAction] = useState(null);
  const [data, setData] = useState(null);
  const [result, setResult] = useState(null);
  const [reloadImage, setReloadImage] = useState(false);

  const openModal = (
    title = null,
    content = null,
    action = null,
    data = null
  ) => {
    setTitle(title);
    setContent(content);
    setAction(action);
    setData(data);
    setResult(null);
    setReloadImage(false);
    setModalOpen(true);
  };

  const closeModal = (result = null, reloadImage = false) => {
    result && setResult(result);
    reloadImage && setReloadImage(reloadImage);
    setData(null);
    setModalOpen(false);
  };

  const value = {
    isModalOpen,
    title,
    content,
    action,
    data,
    result,
    reloadImage,
    setTitle,
    setAction,
    setData,
    openModal,
    closeModal,
  };

  return (
    <ModalContext.Provider value={value}>{children}</ModalContext.Provider>
  );
};
